module.exports = __webpack_public_path__ + "static/media/CaribbeanSaga.b9a731df.png";